<template>
  <v-container>
    <v-btn
      class="ma-auto mb-2"
      color="primary"
      text
      :to="{
        name: 'CurriculumPage',
        params: {
          id: curriculum.id,
        },
      }"
    >
      Return to Curriculum Configuration
    </v-btn>
    <v-card v-if="curriculum">
      <v-card-title> {{ curriculum.name }} Available Courses </v-card-title>
      <v-card-text>
        <template>
          <v-data-table
            :headers="headers"
            :items="curriculum.courses"
            :items-per-page="10"
            class="elevation-1"
          >
            <template v-slot:item.price="props">
              <v-edit-dialog
                :return-value.sync="props.item.price"
                large
                persistent
                @save="savePricing(props.item)"
                @cancel="cancel"
                @open="open"
                @close="close"
              >
                <div>${{ props.item.price }}</div>
                <template v-slot:input>
                  <div class="mt-4 text-h6">
                    Update {{ props.item.name }} Pricing
                  </div>
                  <v-text-field
                    v-model="props.item.price"
                    type="number"
                    step="0.01"
                    min="0"
                    label="Edit"
                    single-line
                    autofocus
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:item.product_url="props">
              <v-edit-dialog
                :return-value.sync="props.item.product_url"
                large
                persistent
                @save="savePricing(props.item)"
                @cancel="cancel"
                @open="open"
                @close="close"
              >
                <div>{{ props.item.product_url }}</div>
                <template v-slot:input>
                  <div class="mt-4 text-h6">Update Product Link</div>
                  <v-text-field
                    v-model="props.item.product_url"
                    label="Edit"
                    single-line
                    autofocus
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
          </v-data-table>
        </template>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable';
import { each as _each, map as _map } from 'lodash-es';

export default {
  name: 'ConfigurePricingPage',
  components: {
    draggable,
  },
  data() {
    return {
      isLoading: false,
      curriculum: null,
      headers: [
        {
          text: 'Course Name',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Product Price',
          align: 'start',
          sortable: true,
          value: 'price',
        },
        {
          text: 'Product Link',
          align: 'start',
          sortable: true,
          value: 'product_url',
        },
      ],
    };
  },

  created() {
    this.fetchCurriculum();
  },

  methods: {
    fetchCurriculum() {
      this.isLoading = true;
      this.axios
        .get('/lms-manager/courses/' + this.$route.params.id, {})
        .then(({ data }) => {
          console.log(data);
          this.curriculum = data;
          this.curriculum.assignedDealer = _map(this.curriculum.dealers, 'id');
          this.curriculum.assignedSpecificDealers = _map(
            this.curriculum.specific_dealers,
            'id'
          );
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
          this.isChanged = false;
        });
    },
    savePricing(item) {
      this.isLoading = true;
      this.axios
        .patch('/lms-manager/product/update/category/' + item.id, {
          price: item.price,
          product_url: item.product_url,
        })
        .then(({ data }) => {
          this.$notify('success', item.name + ' Product Details Updated!');
        })
        .catch()
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped></style>
